import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_AZURE_TENANT_ID;
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;

// Use the current origin so this works in preview AND production without rebuilds.
// Azure must have each origin (e.g. https://mtmu.therapymgmt.com) registered as a SPA redirect URI.
const redirectUri = typeof window !== "undefined" ? window.location.origin : "/";

export const msalConfig = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        knownAuthorities: ["login.microsoftonline.com"],
        redirectUri,
        postLogoutRedirectUri: redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            piiLoggingEnabled: false,
            logLevel: LogLevel.Warning,
            loggerCallback: (level, message) => {
                if (level === LogLevel.Error) {
                    // eslint-disable-next-line no-console
                    console.error("[MSAL]", message);
                }
            },
        },
    },
};

// Scopes for ID-token-based auth. The ID token is what we send to FastAPI.
export const loginRequest = {
    scopes: ["openid", "profile", "email", "User.Read"],
    prompt: "select_account",
};

// When silently refreshing the token to send to our own API, request the
// client's own openid scope so MSAL returns a fresh ID token.
export const apiTokenRequest = {
    scopes: ["openid", "profile", "email"],
};

export const msalInstance = new PublicClientApplication(msalConfig);
